import * as React from "react";
import Box from "@mui/material/Box";
import {
  Avatar,
  Drawer,
  IconButton,
  Tooltip,
  Typography,
} from "@mui/material";
import ModalFooter from "./ModalFooter";
import ModalHeader from "./ModalHeader";
import { info } from "../iconsImports";
import ApiEndpoints from "../network/ApiEndPoints";
import { postFormData } from "../network/ApiController";
import { apiErrorToast, okSuccessToast } from "../utils/ToastUtil";
import { useState } from "react";
import { Icon } from "@iconify/react";

const ApprovePg = ({ row, refresh }) => {
  const [open, setOpen] = useState(false);
  const [request, setRequest] = useState(false);

  const handleApprove = (event) => {
    event.preventDefault();
    postFormData(
      ApiEndpoints.APPROVE_CUSTOMER, // You may want to change this endpoint too
      { status: 1,id: row.id, },
      setRequest,
      (res) => {
        handleClose();
        okSuccessToast(res.data.message);
        if (refresh) refresh();
      },
      (error) => {
        apiErrorToast(error);
      }
    );
  };

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <Box sx={{ display: "grid", justifyContent: "center" }}>
      <Tooltip title="Approve">
        <IconButton sx={{ color: "#28a745" }} onClick={handleOpen}>
          <Icon icon="mdi:check-circle-outline" width={24} height={24} />
        </IconButton>
      </Tooltip>

      <Drawer anchor="right" open={open} onClose={handleClose}>
        <Box sx={{ width: 400 }} className="sm_modal">
          <ModalHeader
            title="Approve Request"
            handleClose={handleClose}
            subtitle="Confirm to proceed with approval"
          />

          <Box
            component="form"
            id="ApprovePgForm"
            noValidate
            autoComplete="off"
            onSubmit={handleApprove}
            sx={{
              textAlign: "center",
              display: "grid",
              justifyContent: "center",
              alignItems: "center",
              px: 3,
            }}
          >
            <Avatar
              src={info}
              alt="info-icon"
              sx={{
                width: 160,
                height: 160,
                objectFit: "cover",
                mx: "auto",
                mb: 2,
              }}
            />
            <Typography variant="h6">Are you sure?</Typography>
            <Typography sx={{ mt: 2 }}>
              You want to approve this request?
            </Typography>
          </Box>

          <Box sx={{ mr: "10px" }}>
            <ModalFooter form="ApprovePgForm" request={request} btn="YES" />
          </Box>
        </Box>
      </Drawer>
    </Box>
  );
};

export default ApprovePg;
